import { AdminClientAnketasTable } from './AdminClientAnketasTable';

export default AdminClientAnketasTable;
